export default __webpack_public_path__ + "static/media/callraise_0011_thumb.4e984147.jpg";